import { readableColorIsBlack } from 'color2k';
import { theme } from '~/theme/theme';

export const getTextColor = (backgroundColor?: string, defaultTextColor = theme.colors.black) => {
    if (!backgroundColor || ['transparent', 'none'].includes(backgroundColor)) {
        return defaultTextColor;
    }

    // Check contrast
    return readableColorIsBlack(backgroundColor) ? theme.colors.nightBlack : theme.colors.offWhite;
};
